(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ComplaintFormDetailController', ComplaintFormDetailController);

    ComplaintFormDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ComplaintForm'];

    function ComplaintFormDetailController($scope, $rootScope, $stateParams, previousState, entity, ComplaintForm) {
        var vm = this;

        vm.complaintForm = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('womenCellApp:complaintFormUpdate', function(event, result) {
            vm.complaintForm = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
